import { render, staticRenderFns } from "./CustomerVerify.vue?vue&type=template&id=063c9a58&scoped=true&"
import script from "./CustomerVerify.vue?vue&type=script&lang=js&"
export * from "./CustomerVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c9a58",
  null
  
)

export default component.exports